import { combineReducers } from "redux";

import { facilityDetails } from "./reducer.facility"
const facilityReducers = combineReducers({
  facilityDetails
})
export default facilityReducers;
